import { useQuery } from "@tanstack/react-query";
import * as api from "./api";

/**
 * 三个查询都通过 TanStack Query 的 queryKey 自动去重 +
 * staleTime (默认 60s, 在 query-client.ts 配的) 缓存,
 * 解决原 cost.html 月份切换抖动 + 重复请求闪烁问题。
 */
export function useDailyStats(month: string) {
  return useQuery({
    queryKey: ["stats", "daily", month],
    queryFn: () => api.fetchDaily(month),
    enabled: !!month,
  });
}

export function useMonthlyStats(months = 12) {
  return useQuery({
    queryKey: ["stats", "monthly", months],
    queryFn: () => api.fetchMonthly(months),
  });
}

export function useByModelStats(month: string) {
  return useQuery({
    queryKey: ["stats", "by-model", month],
    queryFn: () => api.fetchByModel(month),
    enabled: !!month,
  });
}

export function useByUserStats(month: string, enabled: boolean) {
  return useQuery({
    queryKey: ["stats", "by-user", month],
    queryFn: () => api.fetchByUser(month),
    enabled: enabled && !!month,
  });
}

export function useByCompanyStats(month: string, enabled: boolean) {
  return useQuery({
    queryKey: ["stats", "by-company", month],
    queryFn: () => api.fetchByCompany(month),
    enabled: enabled && !!month,
  });
}
